import { useContext } from "react";
import WebInfoContext from "context/WebInfo/WebInfoContext.ts";
import { Helmet } from "react-helmet";
import AboutYung from "Components/about-us";
export default function AboutUs() {
  const { webInfo } = useContext(WebInfoContext);
  return (
    <div className="">
      <Helmet>
        <title>درباره ما</title>
      </Helmet>
      <div className="col-11 my-5 mx-auto">
        {/* <h6 className="text-center mb-3 fw-bold color-rd-01">
          درباره فروشگاه اینترنتی {webInfo?.title}
        </h6> */}
        <div style={{ width: "98%", margin: "auto" }}>
          <AboutYung showTells={true}/>
          {/* <div
            className="footer-content "
            style={{
              lineHeight: 2.4,
              fontSize: 20,
              textAlign: "justify",
              color: "black",
              fontWeight: "bold",
            }}
          >
          </div> */}
       
          {/* <div
            style={{ fontSize: 28, fontWeight: "bold" }}
            className="text-center"
          >
            به زودی ...
          </div> */}
        </div>
      </div>
    </div>
  );
}
